import Vue from 'vue'
import Vuex from 'vuex'
import { API } from '../api/axios'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    availableLanguages: [],
    currentLanguage: '',
    sidebarVisible: false,
    navigationVisible: false,
    authentication: {
      userData: {
        id: null,
        firstname: null,
        middlename: null,
        lastname: null,
        licenseplate: null,
        address: null,
        housenumber: null,
        zipcode: null,
        city: null,
        country: null,
        email: null,
        token: null,
        preferredlanguage: null,
      },
    },
    reservation: null,
    savedQueryParams: {},
    jail: false,
    hideFooter: false,
  },
  actions: {
    initLanguages () {
      let hardcodedLanguages = {
        'languagelist': [
          {
            'id': 'nl',
            'languagename': 'Nederlands',
          },
          {
            'id': 'en',
            'languagename': 'Engels',
          },
          {
            'id': 'de',
            'languagename': 'Duits',
          },
        ],
      }

      this.commit('initLanguages', hardcodedLanguages.languagelist)
      if (!hardcodedLanguages) {
        API.get('languages')
          .then(response => {
            this.commit('initLanguages', response.data.languagelist)
          })
          .catch(() => {
            throw new DOMException('Could not load languages!')
          })
      }
    },
    changeLanguage (lang) {
      console.log('Not implemented yet')
    }
  },
  mutations: {
    initLanguages (state, languages) {
      state.availableLanguages = languages
    },
    changeLanguage (state, newLanguageId) {
      state.currentLanguage = newLanguageId
      state.authentication.userData.preferredlanguage = newLanguageId
    },
    toggleSidebar (state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleNavigation (state) {
      state.navigationVisible = !state.navigationVisible
    },
    changeUserData (state, userData) {
      state.currentLanguage = userData.preferredlanguage
      state.authentication.userData = Object.assign({}, state.authentication.userData, userData)
    },
    addReservation (state, reservation) {
      state.reservation = reservation
    },
    setSavedQueryParams (state, queryParams) {
      // state.savedQueryParams = queryParams
      state.savedQueryParams = Object.assign(queryParams)
    },
    resetSavedQueryParams (state) {
      state.savedQueryParams = {}
    },
    setJail (state, jail) {
      state.jail = jail
    },
    hideFooter (state, hideFooter) {
      state.hideFooter = hideFooter
    },
  },
  getters: {
    sidebarVisible (state) {
      return state.sidebarVisible
    },
    jail (state) {
      return state.jail
    },
    footerHidden (state) {
      return state.hideFooter
    },
    navigationVisible (state) {
      return state.navigationVisible
    },
    language (state) {
      return state.currentLanguage
    },
    languages (state) {
      return state.availableLanguages
    },
    user (state) {
      return state.authentication.userData
    },
    reservation: (state) => state.reservation,
    savedQueryParams (state) {
      return state.savedQueryParams
    },
  },
})



// WEBPACK FOOTER //
// ./src/state/store.js